import { ContextualMenu, ContextualMenuItemType, IContextualMenuProps } from '@fluentui/react';

export { ContextualMenuItemType as IPContextualMenuItemType };

export interface IPContextualMenuProps extends IContextualMenuProps {}

export const IPContextualMenu = (props: IPContextualMenuProps) => {
  return <ContextualMenu {...props} />;
};
